// 檔案下載(移植自國中 batch-records 的 triggerFileDownload)。
// 手機優先走 Web Share 分享面板(iOS Safari 對 <a download> 的 user gesture
// 限制會 silent 擋掉),不支援或使用者取消以外的失敗退回傳統 a.download。
export const triggerFileDownload = async (
  blob: Blob,
  filename: string,
  mimeType: string
): Promise<void> => {
  try {
    if (typeof navigator !== "undefined" && navigator.canShare) {
      const file = new File([blob], filename, { type: mimeType });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: filename });
        return;
      }
    }
  } catch (err) {
    if (err instanceof Error && err.name === "AbortError") return;
    console.warn("Web Share 失敗,改用傳統下載:", err);
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// S3/Windows 非法字元清洗(沿用國中檔名規則)
export const sanitizeFilename = (name: string): string =>
  name.replace(/[\\/:*?"<>|]/g, "");
